import { post } from "@/utils/httpRequest";

const prefix = process.env.VUE_APP_API_URL + "/auth";

const loginUri = prefix + "/login";
const logoutUri = prefix + "/logout";
const checkTokenUri = prefix + "/check_token";

//登录
const login = data =>
  post(loginUri, data, { showMsg: false, showLoading: false });

//登出
const logout = () => post(logoutUri, {});

//检查Token有效性
const checkToken = () => post(checkTokenUri, {}, { showLoading: false });

export default {
  login,
  logout,
  checkToken
};
